/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import Slider from 'react-slick';

import '../scss/slick.scss';
import Color from '@tool/color';
import moSkin from '@store/skin';

interface IProps {}
interface IState {}

const DSlider = styled(Slider)(() => ({
  width: '100%',
  borderRadius: '10px',

  '& .slick-list': { height: '100%' },
  '& .slick-track': { height: '100%' },
  '& .slick-dots': {
    '& li': {
      '&.slick-active': {
        // '& button': {
        //   width: '10px',
        //   height: '10px',
        //   border: `2px solid ${Color.fff}`,
        //   borderRaidus: '5px',

        //   '&::before': { display: 'none' },
        // },
      },
    },
  },
}));

const LoginSlick = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { partner } = moSkin;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="slick-100">
      <DSlider {...{
        dots: true,
        infinite: true,
        autoplaySpeed: 3000,
        // speed: 500,
        arrows: false,
        autoplay: true,
        // slidesToShow: length,
        dotsClass: 'slick-dots dots-100',
      }}>
        <section>
          <section className="slick-1001 slick-1002">
            <section className="line-151">
              <b>对标企业招聘动态</b>
              <p>
                <span>洞察对标企业人才招聘动态 - 知己知彼</span>
                <span>您可以获得多个方面的数据解读，包括企业整体招聘动向、人才需求具体构成、各城市的人才布局、对 标企业的人才招募趋势。从而了解到对标企业在当期阶段的发展动向，以及未来发展趋势</span>
              </p>
            </section>
            <img src="https://file.smartsalary.cn/web-img%402.0/home-banner/company-inline-pic.png" className="pic-11" />
          </section>
        </section>
        <section>
          <section className="slick-1001 slick-1003">
            <section className="line-151">
              <b>行业人力资源核心指标</b>
              <p>
                <span>获取行业人才招聘动向，涨薪率，应届生起薪、离职率、企业弹性福利</span>
              </p>
            </section>
            <img src="https://file.smartsalary.cn/web-img%402.0/home-banner/industry-inline-pic.png" className="pic-11" />
          </section>
        </section>
        {partner === 'smartsalary' ? (
          <section>
            <section className="slick-1001 slick-1004">
              <section className="line-151">
                <b>薪酬白皮书</b>
                <p>
                  <span>数智研究院-帮助HR快速了解行业薪酬动态，行业薪酬报告助力HR快速掌握行业薪酬动向</span>
                </p>
              </section>
              <img src="https://file.smartsalary.cn/web-img%402.0/home-banner/book-inline-pic.png" className="pic-11" />
            </section>
          </section>
        ) : null}
      </DSlider>
    </section>
  );
};

export default observer(LoginSlick);
